import { render, staticRenderFns } from "./LearningOutcome.vue?vue&type=template&id=0b5051bd"
import script from "./LearningOutcome.vue?vue&type=script&lang=js"
export * from "./LearningOutcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports